/* Accessible page entry and confirmed cart updates; purchase logic remains in commerce.js. */
(() => {
 const main=document.querySelector('main,.mi-main,.ac-wrap,.pg-main');
 if(main&&!document.querySelector('.alda-skip')) {
  if(!main.id)main.id='alda-main-content';
  const skip=document.createElement('a');skip.className='alda-skip';skip.href='#'+main.id;skip.textContent='Skip to content';
  skip.addEventListener('click',()=>{main.setAttribute('tabindex','-1');main.focus({preventScroll:true});});
  document.body.prepend(skip);
 }
 const status=document.createElement('div');status.className='alda-sr-only';status.setAttribute('role','status');status.setAttribute('aria-live','polite');document.body.append(status);
 let previous='';
 function watchCart(){
 const count=document.querySelector('.ac-count');
 if(count) {
  previous=count.textContent;
  new MutationObserver(()=>{const next=count.textContent;if(next!==previous){status.textContent=`Cart updated. ${next} items.`;previous=next;}}).observe(count,{childList:true,subtree:true,characterData:true});
 }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watchCart,{once:true});else watchCart();
})();
